export const HOW_IT_WORKS_STRINGS = {
  'selector.title': 'How It Works',
  'selector.reset': 'Choose another profile',
  'selector.homeowners': 'FOR HOMEOWNERS',
  'selector.residents': 'FOR RESIDENTS',
  'selector.homeowner_pro': 'Looking for \nfull management?',
  'selector.homeowner_x': 'Managing your \nhome yourself?',
  'selector.resident_pro': 'Love a Belong home? \nWant to make it yours?',
  'selector.resident_x': 'Already renting \noutside network?',
  'homeowners.switchBtnLabel': 'Switch to Residents',
  'homeowners.title': 'Homeowners',
  'homeowners.ctaLabel': 'Learn More',
  'residents.switchBtnLabel': 'Switch to Homeowners',
  'residents.title': 'Residents',
  'residents.ctaLabel': 'Learn More',
  'tour.loading': 'Building the neighborhood',
  'tour.previous': 'Previous step',
  'tour.next': 'Next step',
  'tour.audience': 'Choose a profile',
  'tour.steps': 'Steps',
  'tour.homeowners.match': 'We find Residents who love your home.',
  'tour.homeowners.matchDetail': 'Fully vetted, with rent guaranteed.',
  'tour.homeowners.loved': 'They move in and stay longer.',
  'tour.homeowners.lovedDetail': 'That means 2/3 less vacancy.',
  'tour.homeowners.care': 'We care for them around the clock.',
  'tour.homeowners.careDetail': 'You stay in the loop on the app.',
  'tour.residents.pay': 'Pay your deposit monthly, not upfront.',
  'tour.residents.payDetail': 'Rent pays itself on the Belong app.',
  'tour.step.introduce': 'Introduce',
  'tour.step.analyze': 'Analyze',
  'tour.step.renovate': 'Renovate',
  'tour.step.style': 'Style',
  'tour.step.list': 'List',
  'tour.step.tour': 'Tour',
  'tour.step.match': 'Match',
  'tour.step.loved': 'Loved',
  'tour.step.care': 'Care',
  'tour.step.apply': 'Apply',
  'tour.step.moveIn': 'Move In',
  'tour.step.pay': 'Pay',
  'tour.step.meet': 'Meet',
  'tour.step.repair': 'Repair',
};
